<!-- <div class="body-content outer-top-xs" id="top-banner-and-menu">
  <div class="container">
    <div class="row"> -->
      <!-- ============================================== SIDEBAR ============================================== -->
      <!-- <div class="col-xs-12 col-sm-12 col-md-3 sidebar">
        <app-side-menu></app-side-menu>
      </div> -->
      <!-- ============================================== CONTENT ============================================== -->
      <div class="homebanner-holder">
        <h1 class="displaynone">Home</h1>
        <ngx-slick-carousel *ngIf="homebannerList!=undefined && homebannerList.length>0" class="carousel home-banner" #slickModal="slick-carousel" [config]="slideConfig">
          <div ngxSlickItem *ngFor="let slide of homebannerList; let index=index" class="slide">
          <a *ngIf="slide.targeturl!=undefined && slide.targeturl!=null && slide.targeturl!=''" target="_blank" href="{{slide.targeturl}}">
            <img src="{{slide.ImageUrl}}" alt="{{slide.Title +''+ slide.Description}}" width="100%">  
          </a>
          <img *ngIf="slide.targeturl==undefined || slide.targeturl==null || slide.targeturl==''" src="{{slide.ImageUrl}}" alt="{{slide.Title +''+ slide.Description}}" width="100%">
            <div class="carousel-caption">
              <span class="big-text">{{slide.Title}}</span>
              <div class="excerpt"> <span>{{slide.Description}}</span> </div>  
              <div class="excerpt"> <a *ngIf="slide.targeturl!=undefined && slide.targeturl!=null && slide.targeturl!=''" target="_blank" href="{{slide.targeturl}}"><button type="submit" class="btn-upper btn btn-primary checkout-page-button" *ngIf="slide.linkname!=undefined && slide.linkname!=null && slide.linkname!=''">{{slide.linkname}}</button></a> </div>  
            </div>          
          </div>
        </ngx-slick-carousel>

        <div id="product-tabs-slider" class="scroll-tabs outer-top-vs wow fadeInUp"
          *ngIf="menuList!=undefined && menuList.length>0">
          <div class="more-info-tab clearfix ">
            <h3 class="new-product-title pull-left">{{catergoryLable}}</h3>
          </div>
          <!-- <ngx-slick-carousel *ngIf="menuList!=undefined && menuList.length>0" 
            class="carousel home-owl-carousel"  #slickModal="slick-carousel" [config]="slideConfig1">
            <div ngxSlickItem *ngFor="let category of menuList; let index=index" class="slide">
              <div class="item">
              <div class="products">
                <div class="product">
                  <div class="product-image">
                    <div class="image ">
                      <a class="cpointer" (click)="catclick(category.tree_node,category.name)">
                        <img src="{{category.image}}" alt="{{category.name +' '+ category.descr}}"
                          *ngIf="category.image != undefined && category.image!=null">
                        <img src="../../assets/images/Product.png" alt="{{category.name +' '+ category.descr}}"
                          *ngIf="category.image == 'NotFound' || category.image==null">
                      </a>
                      <span class="items-dv"><a class="spanbottom"
                          (click)="catclick(category.tree_node,category.name)"> items: {{category.Counts}}
                        </a></span>
                    </div>
                  </div>
                  <div class="product-info text-left">
                    <h3 class="name">
                      <a (click)="catclick(category.tree_node,category.name)">{{category.name}}</a>
                    </h3>
                  </div>
                </div>
              </div>
            </div>
            </div>
          </ngx-slick-carousel> -->
           <div class="search-result-container" >
            <div id="myTabContent" class="tab-content category-list">
                
              <div class="tab-pane active" id="grid-container" >
                <div class="category-product">
                  <div class="row">
                      <div class="col-sm-6 col-md-3 wow fadeInUp" *ngFor="let category of menuList">
                      <div class="products">
                          <div class="product">
                          <div class="product-image">
                            <div class="image aimage">
                              <a class="cpointer" [routerLink]="['/categories',category.tree_node.toLowerCase(), category.name.toLowerCase() | tturls]" *ngIf="category.parent!=0">
                                <img src="../assets/images/Product.png" alt="{{category.name+' ' + category.descr}}" class="pimage" *ngIf="category.image == 'NotFound' || category.image==null">
                              <img src="{{category.image}}" alt="{{category.name +' '+ category.descr}}" class="pimage" *ngIf="category.image != undefined && category.image!=null">
                              </a>
                              <a class="cpointer" [routerLink]="['/category',category.tree_node.toLowerCase(),category.name.toLowerCase() | tturls]" (click)="settreeforsafilgter(category.tree_node)" *ngIf="category.parent==0">
                                <img src="../assets/images/Product.png" alt="{{category.name+' ' + category.descr}}" class="pimage" *ngIf="category.image == 'NotFound' || category.image==null">
                              <img src="{{category.image}}" alt="{{category.name +' '+ category.descr}}" class="pimage" *ngIf="category.image != undefined && category.image!=null">
                              </a>
                              <span class="items-dv">
                                <a class="cpointer" [routerLink]="['/categories',category.tree_node.toLowerCase(), category.name.toLowerCase() | tturls]" *ngIf="category.parent!=0">  items: {{category.Counts}} </a>
                                <a class="cpointer" [routerLink]="['/category',category.tree_node.toLowerCase(), category.name.toLowerCase() | tturls]" (click)="settreeforsafilgter(category.tree_node)" *ngIf="category.parent==0">  items: {{category.Counts}} </a></span>
                            </div>
                            
                          </div>
                          <div class="product-info text-center">
                            
                              <a [routerLink]="['/category',category.tree_node.toLowerCase(), category.name.toLowerCase() | tturls]" (click)="settreeforsafilgter(category.tree_node)" *ngIf="category.parent==0" class="cpointer"> <h2 class="name"> {{category.name}}</h2> </a>
                              <a [routerLink]="['/categories',category.tree_node.toLowerCase(), category.name.toLowerCase() | tturls]" *ngIf="category.parent!=0" class="cpointer"> <h2 class="name"> {{category.name}}</h2> </a>
                               <br />
                             
                            
                          </div>
                          <div id="treedescrgrid" class="product-info tjustify" [innerHTML]="category.descr | safe: 'html'"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                  <a style="margin-left:50%" [routerLink]="['/categories']" class="btn btn-upper btn-primary">View All</a>                 
                </div>
                </div>
                
              </div>
              </div>
              </div> 
        </div>
        <div id="product-tabs-slider" class="scroll-tabs outer-top-vs wow fadeInUp"
          *ngIf="productList!=undefined && productList.length>0">
          <div class="more-info-tab clearfix ">
            <h3 class="new-product-title pull-left">{{HomePageBrandsLable}}</h3>
          </div>
          <ngx-slick-carousel *ngIf="productList!=undefined && productList.length>0" 
            class="carousel home-owl-carousel" #slickModal="slick-carousel" [config]="slideConfig2">
            <div ngxSlickItem *ngFor="let category of productList; let index=index" class="slide">
              <div class="item">
              <div class="products">
                <div class="product">
                  <div class="product-image">
                    <div class="image ">
                      <a class="cpointer" *ngIf="category.maj_class=='' || category.maj_class==undefined" (click)="setprodline(category.product_line)" [routerLink]="['/products', category.product_line.toLowerCase()]">
                        <img src="{{category.image}}" alt="{{category.descr +''+ category.web_descr}}"
                          *ngIf="category.image != undefined && category.image!=null">
                        <img src="../../assets/images/Product.png" alt="{{category.descr +''+ category.web_descr}}"
                          *ngIf="category.image == 'NotFound' || category.image==null">
                      </a>
                      <a class="cpointer" *ngIf="category.maj_class!='' && category.maj_class!=undefined" (click)="getBrandListWithCount(category.maj_class)" [routerLink]="['/product', category.maj_class.toLowerCase()]">
                        <img src="{{category.image}}" alt="{{category.descr +''+ category.web_descr}}"
                          *ngIf="category.image != undefined && category.image!=null">
                        <img src="../../assets/images/Product.png" alt="{{category.descr +''+ category.web_descr}}"
                          *ngIf="category.image == 'NotFound' || category.image==null">
                      </a>
                      <span class="items-dv">
                        <a class="cpointer" *ngIf="category.maj_class!='' && category.maj_class!=undefined" (click)="getBrandListWithCount(category.maj_class)" [routerLink]="['/product', category.maj_class.toLowerCase()]">
                          items: {{category.Counts}}
                        </a>
                        <a class="cpointer" *ngIf="category.maj_class=='' || category.maj_class==undefined" (click)="setprodline(category.product_line)" [routerLink]="['/products', category.product_line.toLowerCase()]">
                          items: {{category.Counts}}
                        </a>
                      </span>
                    </div>
                  </div>
                  <div class="product-info text-left">
                    <h3 class="name">
                      <a class="cpointer" *ngIf="category.maj_class!='' && category.maj_class!=undefined" (click)="getBrandListWithCount(category.maj_class)" [routerLink]="['/product', category.maj_class.toLowerCase()]">
                        {{category.descr}}
                      </a>
                      <a class="cpointer" *ngIf="category.maj_class=='' || category.maj_class==undefined" (click)="setprodline(category.product_line)" [routerLink]="['/products', category.product_line.toLowerCase()]">
                        {{category.descr}}
                      </a>
                    </h3>
                  </div>
                </div>
              </div>
            </div>
            </div>
          </ngx-slick-carousel>
      
        </div>
      </div>
    <!-- </div>
  </div>
</div> -->